<ui-modal
  *ngIf="
    this.originalFormData[scheduleName] &&
    this.originalFormData[scheduleName].length
  "
  [isOpened]="isModalOpened"
  modalTitle="Schedule"
  (isOpenedChange)="modalChanged()"
  size="xl"
>
  <form
    [formGroup]="$any(scheduleArray)"
    (ngSubmit)="saveSchedule()"
    autocomplete="off"
  >
    <div class="panel panel-top">
      <button
        class="ui-button primary"
        (click)="onCopyToClipboardClicked()"
        type="button"
      >
        Copy to clipboard
      </button>
    </div>

    <div class="body">
      <table ui-table id="table-data">
        <thead>
          <tr>
            <th *ngFor="let column of columns">
              {{ column.longName }}
            </th>

            <th *ngFor="let addColumn of additionalColumns">
              {{ addColumn.longName }}
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let item of scheduleArrayControls; index as i">
              <ng-container [formGroupName]="i">
                <td
                  *ngFor="let column of columns; index as columnIndex"
                  class="data-cell"
                  #tableResults
                  (mouseenter)="
                    mouseEnterField(item.controls[column.shortName])
                  "
                  (mouseleave)="mouseLeaveField()"
                >
                  <ng-container
                    *ngIf="column.shortName === 'fixingNumber'; else inputBlock"
                  >
                    {{ item.controls[column.shortName].value }}
                  </ng-container>
                  <ng-template #inputBlock>
                    <ng-container
                      *ngIf="
                        item.controls[column.shortName];
                        else notEnabledInput
                      "
                    >
                      <ng-container [ngSwitch]="column.inputType">
                        <input
                          *ngSwitchCase="'text'"
                          type="text"
                          class="input-field"
                          (change)="
                            attributeBlur(
                              $any($event.target).value,
                              column.shortName,
                              i,
                              $any($event).inputType,
                              item.controls[column.shortName]
                            )
                          "
                          (focus)="
                            selectedFieldElem = $event.target;
                            textBoxCaretRestrictionHandler(
                              item.controls[column.shortName].value
                            )
                          "
                          (paste)="onPaste($event, i, columnIndex)"
                          [formControlName]="column.shortName"
                          [readonly]="
                            rfqLegSettings.static
                              ? true
                              : (column.shortName
                                | scheduleFieldDisabled
                                  : originalFormData
                                  : additionalColumns)
                          "
                        />

                        <input
                          *ngSwitchCase="'checkbox'"
                          type="checkbox"
                          class="clr-toggle"
                          [formControlName]="column.shortName"
                        />
                      </ng-container>
                    </ng-container>

                    <ng-template #notEnabledInput>
                      <input type="text" class="input-field" disabled />
                    </ng-template>
                  </ng-template>
                </td>

                <td
                  *ngFor="let addColumn of additionalColumns"
                  class="data-cell"
                  #tableResults
                >
                  <input
                    *ngIf="
                      flows && flows[i] && flows[i][addColumn.shortName] != null
                    "
                    type="text"
                    class="input-field"
                    [value]="flows[i][addColumn.shortName]"
                    [readonly]="
                      rfqLegSettings.static
                        ? true
                        : (addColumn.shortName
                          | scheduleFieldDisabled
                            : originalFormData
                            : additionalColumns)
                    "
                  />
                </td>
              </ng-container>
              <!-- <td></td> -->
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <p *ngIf="showTotalNotional">
      &nbsp;Total notional: {{ totalNotional | number: '1.0-0' }}
      {{ notionalCurrency }}
    </p>

    <div class="panel panel-errors">
      <div class="panel-errors__error">
        {{ scheduleArray.errors?.invalidEntry?.value }}
      </div>

      <div class="panel-errors__error" *ngIf="hoveredError">
        <b>Hovered Field</b>: {{ hoveredError }}
      </div>
    </div>

    <div class="panel panel-bottom">
      <button
        class="ui-button primary"
        type="submit"
        [disabled]="!this.scheduleArray.valid"
      >
        Save
      </button>
    </div>
  </form>
</ui-modal>
